import React from 'react';
import { Link } from 'react-router-dom';
import './Steak.css';

const Steak = () => {
  return (
    <div className="donate-page">
      <div className="donate-container">
        <Link to="/" className="back-link">
          ← Back to Home
        </Link>

        <h1 className="donate-title">Buy Me A Steak</h1>

        <div className="donate-content">
          <section className="donate-section intro">
            <p className="tagline">
              Enjoying Carnivores Adapting Terribly? Help keep the servers running and the
              development going!
            </p>
            <p>
              This game is free. But hosting, development, and steak aren't. If you'd like to
              support the project, here's how:
            </p>
          </section>

          <div className="donation-options">
            <div className="donation-card buymeacoffee-card">
              <div className="card-icon">☕</div>
              <h2>Buy Me A Coffee</h2>
              <p>Quick and easy one-time contributions via Buy Me A Coffee</p>
              <a
                href="https://buymeacoffee.com/carnivores"
                target="_blank"
                rel="noopener noreferrer"
                className="donate-button bmac-button"
              >
                <span className="button-icon">☕</span>
                Support on Buy Me A Coffee
              </a>
              <p className="note">Accepts credit cards, Apple Pay, Google Pay</p>
            </div>

            <div className="donation-card lightning-card">
              <div className="card-icon">⚡</div>
              <h2>Bitcoin Lightning</h2>
              <p>Instant, low-fee Bitcoin payments via Lightning Network</p>
              <a
                href="https://checkout.opennode.com/p/accac5ac-be1d-4253-a1a6-b90d780c8121"
                target="_blank"
                rel="noopener noreferrer"
                className="donate-button lightning-button"
              >
                <img
                  src="https://app.opennode.com/icons/pay-with-bitcoin.svg"
                  alt="Pay with Bitcoin"
                  className="bitcoin-button-img"
                />
              </a>
              <p className="note">Bitcoin, not shitcoins</p>
            </div>
          </div>

          <section className="donate-section">
            <h2>Where Does The Money Go?</h2>
            <ul>
              <li>
                <strong>Infrastructure:</strong> Keeping the game running and scalable
              </li>
              <li>
                <strong>Development:</strong> New features, bug fixes, improvements
              </li>
              <li>
                <strong>Content:</strong> Writing new cards and game modes
              </li>
              <li>
                <strong>Operations:</strong> All the boring stuff that makes it work
              </li>
            </ul>
          </section>

          <section className="donate-section">
            <h2>Other Ways to Support</h2>
            <p>Not ready to contribute financially? No problem! You can still help by:</p>
            <ul>
              <li>
                <strong>Sharing the game:</strong> Tell your friends, share on social media
              </li>
              <li>
                <strong>Reporting bugs:</strong> Help us make the game better for everyone
              </li>
              <li>
                <strong>Suggesting features:</strong> Got ideas? We're listening -{' '}
                <Link to="/contact" className="contact-link">
                  contact us
                </Link>
              </li>
              <li>
                <strong>Playing regularly:</strong> Active players make the project worth it
              </li>
            </ul>
          </section>

          <section className="donate-section thanks">
            <h2>Thank You!</h2>
            <p>
              Whether you contribute or just play the game, thank you for supporting Carnivores
              Adapting Terribly. Your support keeps this project alive and growing.
            </p>
            <p className="tagline">
              Now get back to the game and make some terrible card combinations.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Steak;
